var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "topic-column",
    on: {
      "dragover": function dragover($event) {
        $event.preventDefault();
        return function () {}.apply(null, arguments);
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return function () {}.apply(null, arguments);
      },
      "dragenter": _vm.throttleDragoverTopic
    }
  }, [_c('grid', {
    attrs: {
      "length": _vm.length
    }
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }